<script lang="ts">
  import { afterNavigate } from '$app/navigation';
  import { DividerHorizontal, DividerResponsive } from '$lib/components/divider';
  import { ComponentStatus } from '$lib/components';
  import { PageHead } from '$lib/components/page';
  import { TextSection, TextStatus } from '$lib/components/text';
  import { AppPath } from '$lib/features/app';
  import type { CompanyDto } from '$lib/features/bff/sdk';
  import {
    CompanyHeader,
    CompanyTextInfoGroup,
    CompanyTextInfoGroupSimples,
    CompanyTableMember,
    CompanyTableOffice,
  } from '$lib/features/company';
  import { formatCompanyId } from '$lib/features/format';
  import { addHistoryItem } from '$lib/features/office';

  export let data;
  let company: CompanyDto;

  $: company = data.company;
  $: ({ cache, name, equity, jurisdiction, nature, size } = company || ({} as CompanyDto));
  $: ({ simei, simples, members, offices } = company || ({} as CompanyDto));
  $: updated = cache?.find((c) => c.key === 'SIMPLES')?.updated;

  /**
   * Add item to local history
   */
  afterNavigate(async () => {
    const { id, name } = data.company;

    addHistoryItem({
      id: String(id),
      label: name,
      value: formatCompanyId(id),
      href: `${AppPath.COMPANY}/${id}`,
    });
  });
</script>

{#if company}
  <PageHead title={name} robots="noindex" />

  <CompanyHeader {company} />

  <DividerHorizontal margin="my-8" />

  <!-- Company and Simples -->
  <DividerResponsive leadWidth="lg:w-2/3" trailWidth="lg:w-1/3">
    <svelte:fragment slot="lead">
      <TextSection tag="h2" font="text-xl" title="Cadastro Empresarial">
        <CompanyTextInfoGroup {equity} {jurisdiction} {name} {nature} {size} />
      </TextSection>
    </svelte:fragment>

    <svelte:fragment slot="trail">
      <TextSection tag="h2" font="text-xl" title="Regime Tributário">
        <CompanyTextInfoGroupSimples {simei} {simples} {updated} />
      </TextSection>
    </svelte:fragment>
  </DividerResponsive>

  <DividerHorizontal margin="my-8" />

  <!-- Offices -->
  <TextSection tag="h2" font="text-xl" title="Estabelecimentos">
    <CompanyTableOffice {offices} />
  </TextSection>

  <DividerHorizontal margin="my-8" />

  <!-- Members -->
  <TextSection tag="h2" font="text-xl" title="Sócios e Administradores">
    <CompanyTableMember {members} />
  </TextSection>
{:else}
  <TextStatus status={ComponentStatus.PROCESSING} label="Consultando..." />
{/if}
